import React from 'react';
import PropTypes from 'prop-types';
import {compose} from 'react-apollo';
import {renderGraphQLStatusOrNull} from "../../../utils/utils";
import TextField from '../../material/TextField';
import OverlayController from "../../overlay/OverlayController";
import userContext from "../../../services/userContext";
import queries from "../../../graphql/queries";
import moment from 'moment';
import _ from 'lodash';
import './CommentsPlugin.css';


export default compose(
    queries.userListQueryHoc,
)(class PluginItemView extends React.Component {

    static propTypes = {
        configuration: PropTypes.object,
        projectId: PropTypes.string.isRequired,
        item: PropTypes.object.isRequired,
        updateItem: PropTypes.func.isRequired,
        reportEvent: PropTypes.func.isRequired,
        refreshQueues: PropTypes.func.isRequired,
        userListData: PropTypes.object.isRequired
    };

    static defaultProps = {};

    constructor(props) {
        super(props);

        this.state = {
            message: ''
        };
    }

    onMessageChange = (event) => {
        this.setState({message: event.target.value});
    };

    onKeyDown = (event) => {
        if (event.keyCode === 13 && this.state.message.trim().length > 0) {
            event.preventDefault();
            this.updateItem();
            this.setState({message: ''});
        }
    };

    updateItem() {
        OverlayController.showActivityIndicator();
        let user = userContext.getCurrentUser();
        let hasComments = _.has(this.props.item, 'data.comments');
        let updateCommand = hasComments ? '$push' : '$set';
        this.props.updateItem({
            data: {
                comments: {
                    [updateCommand]: [{
                        author: {
                            id: user.id,
                            name: user.name,
                            email: user.email
                        },
                        createdAt: (new Date()).getTime(),
                        text: this.state.message.trim()
                    }]
                }
            }
        }).then(() => {
            OverlayController.hideActivityIndicator();
        }).catch((error) => {
            OverlayController.hideActivityIndicator();
            OverlayController.showErrorAlert(error);
        });
    }

    renderCommentsList() {
        let userMapById = _.keyBy(this.props.userListData.userList, 'id');
        let listItems = _.get(this.props.item, 'data.comments', []).map((comment, index) => {
            // if we have user object from database user it (to use fresh user name)
            // if not, use the one that was stored when comment was created.
            let user = userMapById[comment.author.id] || comment.author;
            let userName = user.name || user.email;
            return (
                <li key={index} className="commentsListItem">
                    <div className="commentInfo">
                        <span className="commentUserName">{userName}</span>
                        <span className="commentTime">{moment(comment.createdAt).format('ddd, MMM D LT')}</span>
                    </div>
                    <div className="commentsMessage">{comment.text}</div>
                </li>
            );
        });

        return <ul className="commentsList">{listItems}</ul>;
    }

    renderTextField() {
        return (
            <TextField
                value={this.state.message}
                placeholderText="Write your comment here"
                multiLine={true}
                onChange={this.onMessageChange}
                inputProps={{onKeyDown: this.onKeyDown}}
            />
        );
    }

    render() {
        return renderGraphQLStatusOrNull(this.props.userListData) || (
            <div className="commentsPlugin">
                {this.renderCommentsList()}
                {this.renderTextField()}
            </div>
        );
    }
});



// WEBPACK FOOTER //
// ./src/components/plugins/commentsPlugin/PluginItemView.js